export const FORMAT = 'DD.MM';
export const WEEK_FORMAT = 'dddd';
export const HEADER_FORMAT = 'D. MMMM';
export const HOURS_FORMAT = 'HH:mm';
export const DEFAULT_FORMAT = 'YYYY-MM-DD';
export const SELECTED_DAY_FORMAT = 'DD.MM.YYYY';
export const DEFAULT_FORMAT_HOUR_MIN = 'YYYY-MM-DD HH:mm:ss';
